export enum PageSubType {
    HOME = 'HOME',
    BOOKING = 'BOOKING',
}
